/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const r={current:null},n={current:!1};export{n as hasReducedMotionListener,r as prefersReducedMotion};
//# sourceMappingURL=state.js.map
